<div class="bottom-actions ion-padding">
  <ng-content></ng-content>
</div>
